// Display-format helpers for order enum values.
// Wire format is lowercase snake_case; UI shows Title Case With Spaces.

import type { OrderStatus, Side, OrderType, TimeInForce } from '../types/api';

function titleCase(s: string): string {
  return s
    .split('_')
    .map(w => (w.length === 0 ? w : w[0].toUpperCase() + w.slice(1)))
    .join(' ');
}

export function formatStatus(status: OrderStatus): string {
  return titleCase(status);
}

export function formatSide(side: Side): string {
  return titleCase(side);
}

export function formatOrderType(orderType: OrderType): string {
  return titleCase(orderType);
}

export function formatTimeInForce(tif: TimeInForce): string {
  // Acronyms stay uppercase
  if (tif === 'gtc' || tif === 'ioc' || tif === 'fok') return tif.toUpperCase();
  return titleCase(tif);
}
